import { defaultDate } from '@/datas/DateFormats'
import { getFuturePeriod, getNow } from '@/helpers/date'

export const typeContract = {
  notActual: 'Актуальный договор не назначен',
  isActual: 'Назначен актуальный',
  signedAndDownload: 'Договор подписан и загружен',
  notSign: 'Договор не подписан',
  notDownload: 'Договор не загружен',
}
export const hints = {
  default:
    'При создании заявки, старайтесь. указывать информацию как можно полней. ' +
    'От этого зависит количество возможных контактов',
  driverFio: 'Укажите полностью через пробел Ваши фамилию, имя и отчество',
}

export const user_types = {
  1: 'Администратор',
  2: 'Экспортер',
  3: 'Диспетчер',
  4: 'Перевозчик',
  5: 'Менеджер',
  6: 'СЕО',
}

export const fast_link_data = {
  percent: ['0.15 %', '0.17 %', '0.2 %', '0.3 %', '200 кг'],
  pay_type: ['перечислением', 'на карту'],
  day_pay: ['3-и сутки', 'со вторых суток на терминале'],
  avance_when: ['после погрузки', 'по приезду на погрузку'],
}

export const autocompleteSettingsOne = {
  regionLoad: {
    controller: 'kladr',
    keyName: ['name', ' ', 'type'],
    params: { contentType: 'region' },
  },
  kladrLoad: {
    controller: 'kladr',
    keyName: ['type', ' ', 'name'],
    params: { contentType: 'city', regionId: null },
  },
}

export const autocompleteSettingsTwo = {
  regionUnLoad: {
    controller: 'kladr',
    keyName: ['name', ' ', 'type'],
    params: { contentType: 'region' },
  },
  kladrUnLoad: {
    controller: 'kladr',
    keyName: ['type', ' ', 'name'],
    params: { contentType: 'city', regionId: null },
  },
}

const shortcuts = [
  {
    text: 'Вчера',
    onClick(picker) {
      picker.$emit('pick', getFuturePeriod(defaultDate, -1))
    },
  },
  {
    text: 'Сегодня',
    onClick(picker) {
      picker.$emit('pick', getNow(defaultDate))
    },
  },
  {
    text: 'Завтра',
    onClick(picker) {
      picker.$emit('pick', getFuturePeriod(defaultDate, 1))
    },
  },
]

export const pickerOptions = {
  firstDayOfWeek: 1,
  disabledDate(time) {
    return time.getTime() <= getFuturePeriod('x', -2)
  },
  shortcuts,
}

export const pickerOpt = {
  firstDayOfWeek: 1,
  shortcuts,
}

export const pickerRangeOpt = {
  firstDayOfWeek: 1,
  shortcuts: [
    {
      text: 'Посл. неделя',
      onClick(picker) {
        const start = getFuturePeriod(defaultDate, -7)
        const end = getNow(defaultDate)

        picker.$emit('pick', [start, end])
      },
    },
    {
      text: 'Вчера',
      onClick(picker) {
        const date = getFuturePeriod(defaultDate, -1)

        picker.$emit('pick', [date, date])
      },
    },
    {
      text: 'Сегодня',
      onClick(picker) {
        const date = getNow(defaultDate)

        picker.$emit('pick', [date, date])
      },
    },
  ],
}

export const DEFAULT_VIN_VALUE = 'VIN не указан'
export const MAIN_ORGANIZATION_DATA = {
  inn: '2315190510',
  short_name: 'ООО "ПОРТ ТРАНЗИТ"',
} // ООО Порт-Транзит
export const PTE_ORGANIZATION_DATA = {
  inn: '2315996340',
  short_name: 'ООО "ПОРТ ТРАНЗИТ"',
} // ООО ПТЭ

export const entryStatuses = [
  'Находится на рассмотрении',
  'Утвержден на погрузку',
  'Заявка отклонена',
]

export const months = [
  'январе',
  'феврале',
  'марте',
  'апреле',
  'мае',
  'июне',
  'июле',
  'августе',
  'сентябре',
  'октябре',
  'ноябре',
  'декабре',
]

export const typeCodes = [
  { label: 'delivery', title: 'Перевозка' },
  { label: 'harvest', title: 'Уборка' },
  {
    label: 'harvest_or_delivery',
    title: 'Уборка и',
    sub: 'Перевозка',
    full: 'Уборка и перевозка',
  },
]

export const typeCodesShort = [
  { label: 'delivery', title: 'Перевозка' },
  { label: 'harvest', title: 'Уборка' },
]

export const typeCodesFilters = [
  { label: 'delivery', title: 'Перевозка' },
  { label: 'harvest,harvest_or_delivery', title: 'Уборка' },
]
